import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {InquiryExtensionContainerModel} from '../../../../../../models/aggregates/erp/inquiry';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class InquiryExtService extends BaseApiTemplateService<InquiryExtensionContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'inquiries-exts';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'inquiries-exts';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'inquiries-exts';
    this.httpClient = http;
  }

}


